import { createGetAsyncSlice } from '@sonar-software/xuder';
import { getDataSecurityDataAccessSearchHistory } from '@api/data-security';

export const getCoreDataSecurityDataAccessSearchHistorySlice = createGetAsyncSlice({
	name: 'CoreDataSecurityDataAccessSearchHistory',
	receive: true,
	request: true,
	requestHandler: getDataSecurityDataAccessSearchHistory,
	retainDataOnRequest: true
});
